import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId1178: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://forever.travel-assets.com/flex/flexmanager/images/2020/09/04/TD_BF__HeroImage.jpeg",
  },
  car: {
    iHaveDiscount: "wizard.car.having.brand.title",
  },
};
